// Generated types for RFLPElement
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RFLPElementReadAPI extends ScopedNodeReadAPI {
  /** Human-readable name */
  name: string;
  /** Name used for this element in Constraint / DerivedExpression expressions. Derived from `name` when first saved; immutable after. */
  slug?: string | null;
  /** Textual description */
  description?: string | null;
}

export interface RFLPElementWriteAPI extends ScopedNodeWriteAPI {
  /** Human-readable name */
  name: string;
  /** Name used for this element in Constraint / DerivedExpression expressions. Derived from `name` when first saved; immutable after. */
  slug?: string | null;
  /** Textual description */
  description?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RFLPElementReadAPISchemaObject = ScopedNodeReadAPISchemaObject.extend({
  name: z.string(),
  slug: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
}).passthrough();
export const RFLPElementReadAPISchema: z.ZodType<RFLPElementReadAPI> = RFLPElementReadAPISchemaObject;

export const RFLPElementWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({
  name: z.string(),
  slug: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
}).passthrough();
export const RFLPElementWriteAPISchema: z.ZodType<RFLPElementWriteAPI> = RFLPElementWriteAPISchemaObject;
